module.exports = __webpack_public_path__ + "img/illustrator-noData.1ccda479.svg";